import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@rq-ratings/pro-regular-svg-icons'
import React from 'react'

import ActionButton from '../../ActionButton'
import { useDeleteLinkMutation } from '../hooks/useDeleteLinkMutation'

interface Props {
  referralLinkCode: string
}

const DeleteLinkButton: React.FC<Props> = ({ referralLinkCode }) => {
  const deleteLinkMutation = useDeleteLinkMutation()

  return (
    <>
      <ActionButton
        isProcessing={deleteLinkMutation.isPending}
        isProcessingText="Deleting"
        variant="outline-danger"
        className="d-flex justify-content-center align-items-center gap-2"
        size="sm"
        onClick={() => {
          const hasConfirmedAction = window.confirm(
            'Are you sure you want to delete this link? This action cannot ' +
              'be undone. Any users who have this link will no longer be ' +
              'able to use it.',
          )

          if (hasConfirmedAction) {
            deleteLinkMutation.mutate(referralLinkCode)
          }
        }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
        Delete
      </ActionButton>
    </>
  )
}

export default DeleteLinkButton
